export default __webpack_public_path__ + "static/media/every-conference-call-ever.11009932.md";